// extracted by mini-css-extract-plugin
export default {"product_item":"SingleProductPage_product_item__+shh5","add_btn":"SingleProductPage_add_btn__DkSui"};